export const FEINPrefixLookup = [
  {
  EIN_prefix: 10,
  EIN_campus_id: 1,
  EIN_campus: "Andover"
  },
  {
    EIN_prefix: 12,
    EIN_campus_id: 1,
    EIN_campus: "Andover"
  },
  {
    EIN_prefix: 60,
    EIN_campus_id: 2,
    EIN_campus: "Atlanta"
  },
  {
    EIN_prefix: 67,
    EIN_campus_id: 2,
    EIN_campus: "Atlanta"
  },
  {
    EIN_prefix: 50,
    EIN_campus_id: 3,
    EIN_campus: "Austin"
  },
  {
    EIN_prefix: 53,
    EIN_campus_id: 3,
    EIN_campus: "Austin"
  },
  {
    EIN_prefix: parseInt('01'),
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: parseInt('02'),
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: parseInt('03'),
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: parseInt('04'),
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: parseInt('05'),
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: parseInt('06'),
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: 11,
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: 13,
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: 14,
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: 16,
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: 21,
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: 22,
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: 23,
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: 25,
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: 34,
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: 51,
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: 52,
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: 54,
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: 55,
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: 56,
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: 67,
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: 58,
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: 59,
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: 65,
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: 30,
    EIN_campus_id: 5,
    EIN_campus: "Cincinnati"
  },
  {
    EIN_prefix: 32,
    EIN_campus_id: 5,
    EIN_campus: "Cincinnati"
  },
  {
    EIN_prefix: 35,
    EIN_campus_id: 5,
    EIN_campus: "Cincinnati"
  },
  {
    EIN_prefix: 36,
    EIN_campus_id: 5,
    EIN_campus: "Cincinnati"
  },
  {
    EIN_prefix: 37,
    EIN_campus_id: 5,
    EIN_campus: "Cincinnati"
  },
  {
    EIN_prefix: 38,
    EIN_campus_id: 5,
    EIN_campus: "Cincinnati"
  },
  {
    EIN_prefix: 61,
    EIN_campus_id: 5,
    EIN_campus: "Cincinnati"
  },
  {
    EIN_prefix: 15,
    EIN_campus_id: 6,
    EIN_campus: "Fresno"
  },
  {
    EIN_prefix: 24,
    EIN_campus_id: 6,
    EIN_campus: "Fresno"
  },
  {
    EIN_prefix: 40,
    EIN_campus_id: 7,
    EIN_campus: "Kansas City"
  },
  {
    EIN_prefix: 44,
    EIN_campus_id: 7,
    EIN_campus: "Kansas City"
  },
  {
    EIN_prefix: 94,
    EIN_campus_id: 8,
    EIN_campus: "Memphis"
  },
  {
    EIN_prefix: 95,
    EIN_campus_id: 8,
    EIN_campus: "Memphis"
  },
  {
    EIN_prefix: 80,
    EIN_campus_id: 9,
    EIN_campus: "Ogden"
  },
  {
    EIN_prefix: 90,
    EIN_campus_id: 9,
    EIN_campus: "Ogden"
  },
  {
    EIN_prefix: 33,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 39,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 41,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 42,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 43,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 45,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 46,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 47,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 48,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 62,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 63,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 64,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 66,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 68,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 71,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 72,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 73,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 74,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 75,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 76,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 77,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 81,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 82,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 83,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 84,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 85,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 86,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 87,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 88,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 91,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 92,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 93,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 98,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 99,
    EIN_campus_id: 10,
    EIN_campus: "Philadelphia"
  },
  {
    EIN_prefix: 20,
    EIN_campus_id: 11,
    EIN_campus: "Internet"
  },
  {
    EIN_prefix: 26,
    EIN_campus_id: 11,
    EIN_campus: "Internet"
  },
  {
    EIN_prefix: 27,
    EIN_campus_id: 11,
    EIN_campus: "Internet"
  },
  {
    EIN_prefix: 31,
    EIN_campus_id: 12,
    EIN_campus: "Small Business Administration"
  },
  {
    EIN_prefix: 57,
    EIN_campus_id: 4,
    EIN_campus: "Brookhaven"
  },
  {
    EIN_prefix: 97,
    EIN_campus_id: null,
    EIN_campus: "American Samoa"
    
  },
  {
    EIN_prefix: 96,
    EIN_campus_id: null,
    EIN_campus: "Guam"
  }
];
